import { AlertColor } from '@mui/material'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface UserInfo {
  displayName: string | null
  email: string | null
  phoneNumber: string | null
  photoURL: string | null
  providerId: string
  uid: string
}

export interface IAppState {
  isLoading: boolean
  userInfo: UserInfo | null
  alert:
    | {
        severity: AlertColor
        message: string
      }
    | undefined
  customerProfileId: number | undefined
  subscriptionIds: string[] | undefined
}

const initialState: IAppState = {
  isLoading: false,
  userInfo: null,
  alert: undefined,
  customerProfileId: undefined,
  subscriptionIds: undefined,
}

export const slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    onIsLoading: (
      state: IAppState,
      action: PayloadAction<typeof initialState.isLoading>
    ) => {
      state.isLoading = action.payload
    },
    onUserInfo: (
      state: IAppState,
      action: PayloadAction<typeof initialState.userInfo>
    ) => {
      state.userInfo = action.payload
    },
    onAlert: (
      state: IAppState,
      action: PayloadAction<typeof initialState.alert>
    ) => {
      state.alert = action.payload
    },
    onCustomerProfileId: (
      state: IAppState,
      action: PayloadAction<typeof initialState.customerProfileId>
    ) => {
      state.customerProfileId = action.payload
    },
    onSubscriptionIds: (
      state: IAppState,
      action: PayloadAction<typeof initialState.subscriptionIds>
    ) => {
      state.subscriptionIds = action.payload
    },
  },
})

export const { actions, reducer } = slice

/** Root state shape for the app slice (state.app). */
export type AppRootState = {
  app: IAppState
}

/** @deprecated Use AppRootState. Kept for backward compatibility. */
export type IApp = AppRootState
